import {
	Id,
	LaravelResponse,
	ModelUsageResource,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import {
	ContactFilterIndexResource,
	ContactFilterOptionResource,
	ContactFilterSaveRequest,
	ContactFilterType,
	ContactFilterUpdateResource,
} from "../types";

const baseKey = "contact-filters";

const forSidebarKey = [baseKey, "for-sidebar"];
const baseOptionsKey = [baseKey, "options"];
const showUsageKey = (filterId: Id) => [...contactFilterService.showKey(filterId), "usage"];

export const contactFilterService = {
	...withIndexEndpoint<ContactFilterIndexResource>([baseKey]),
	...withShowEndpoint<ContactFilterUpdateResource>([baseKey]),
	...withDestroyEndpoint([baseKey]),
	...withStoreEndpoint<ContactFilterSaveRequest>([baseKey]),
	...withUpdateEndpoint<ContactFilterSaveRequest>([baseKey]),
	options: (search: string, page: number, types: ContactFilterType[]) =>
		axios.get<LaravelResponse<ContactFilterOptionResource[]>>(keyToUrl(baseOptionsKey), {
			params: { search, page, types },
		}),
	baseOptionsKey,
	optionsKey: (types: ContactFilterType[]) => [...baseOptionsKey, ...types],
	forSidebar: () => axios.get<LaravelResponse<ContactFilterIndexResource[]>>(keyToUrl(forSidebarKey)),
	forSidebarKey,
	showUsageKey,
	showUsage: (filterId: Id) => axios.get<LaravelResponse<ModelUsageResource[]>>(keyToUrl(showUsageKey(filterId))),
};
